var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeeblinklogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.438,
    height: 90.468,
    viewBox: "0 0 110.438 90.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_73",
    "data-name": "Gruppe 73",
    transform: "translate(18855.695 -10664.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_68",
    "data-name": "Gruppe 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_32",
    "data-name": "Pfad 32",
    d: "M0,0H22.154",
    transform: "translate(-18812.5 10667.5)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    "data-name": "Pfad 31",
    d: "M0,0H0V21.7",
    transform: "translate(-18790.014 10667.641)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_15",
    "data-name": "Linie 15",
    x1: 0.035,
    y2: 21.449,
    transform: "translate(-18813.021 10667.641)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    "data-name": "Pfad 33",
    d: "M6.629,0H0",
    transform: "translate(-18819.691 10688.757)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_18",
    "data-name": "Linie 18",
    x1: 3.949,
    y2: 4.782,
    transform: "translate(-18823.5 10688.718)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_20",
    "data-name": "Linie 20",
    x1: 55.42,
    transform: "translate(-18834.027 10693.936)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_21",
    "data-name": "Linie 21",
    x1: 17,
    y2: 23,
    transform: "translate(-18851.5 10694.5)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_23",
    "data-name": "Linie 23",
    x1: 97,
    y2: 0.474,
    transform: "translate(-18851.5 10717.5)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_24",
    "data-name": "Linie 24",
    y1: 9.009,
    transform: "translate(-18846.039 10722.309)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_32",
    "data-name": "Linie 32",
    x1: 2.73,
    y1: 4.641,
    transform: "translate(-18848.77 10717.893)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_33",
    "data-name": "Linie 33",
    y1: 4.368,
    x2: 2.73,
    transform: "translate(-18756.959 10717.898)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_26",
    "data-name": "Linie 26",
    x2: 6.825,
    y2: 20.475,
    transform: "translate(-18846.039 10730.698)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_28",
    "data-name": "Linie 28",
    x1: 75.43,
    transform: "translate(-18839.215 10751.174)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_27",
    "data-name": "Linie 27",
    x1: 6.825,
    y2: 20.475,
    transform: "translate(-18763.785 10730.698)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_25",
    "data-name": "Linie 25",
    y1: 9.282,
    transform: "translate(-18756.959 10722.039)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_19",
    "data-name": "Linie 19",
    x2: 4.947,
    y2: 4.782,
    transform: "translate(-18783.447 10688.718)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_17",
    "data-name": "Linie 17",
    x1: 6.19,
    y1: 0.257,
    transform: "translate(-18789.5 10688.5)",
    fill: "none",
    stroke: "#3b82f5",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_71",
    "data-name": "Gruppe 71",
    transform: "translate(-388 3)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_60",
    "data-name": "Linie 60",
    x1: 10,
    transform: "translate(-18371.5 10686.5)",
    fill: "none",
    stroke: "#3bc2f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_63",
    "data-name": "Linie 63",
    y2: 10,
    transform: "translate(-18361.5 10686.5)",
    fill: "none",
    stroke: "#3bc2f5",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_64",
    "data-name": "Linie 64",
    x1: 15,
    y2: 15,
    transform: "translate(-18376.5 10686.5)",
    fill: "none",
    stroke: "#3bc2f5",
    strokeLinecap: "round",
    strokeWidth: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeblinklogo);
export default __webpack_public_path__ + "static/media/keeblinklogo.6e1b346f321a9dbebcc45663c7a156a6.svg";
export { ForwardRef as ReactComponent };